import * as Yup from 'yup';

export const validation = Yup.object({
    name: Yup.string()
        .required('Názov súhlasu je povinný.'),
    issuingAuthority: Yup.object()
        .nullable()
        .required('Vydávajúci orgán je povinný.'),
    consentType: Yup.string()
        .required('Typ súhlasu je povinný.'),
    decisionNumber: Yup.string()
        .required('Číslo rozhodnutia je povinné.'),
    validFrom: Yup.date()
        .typeError('Dátum právoplatnosti je povinný.')
        .required('Dátum právoplatnosti je povinný.'),
    validUntil: Yup.date()
        .nullable()
        .required('Dátum platnosti je povinný.'),
    wasteCodes: Yup.array()
        .min(1, 'Vyberte aspoň jeden kód odpadu.')
        .required('Kódy odpadov sú povinné.'),
    loadingCodes: Yup.array()
        .min(1, 'Vyberte aspoň jeden kód nakladania.')
        .required('Kódy nakladania sú povinné.'),
});
